<main role="main" >
    <section>
        <article>
            <app-tandartsFR-header></app-tandartsFR-header>
            <app-tandarts-content></app-tandarts-content>
        </article>
    </section>
</main>